/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFirstAidKit = createReactComponent("outline", "first-aid-kit", "IconFirstAidKit", [["path", { "d": "M8 8v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M4 8m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M10 14h4", "key": "svg-2" }], ["path", { "d": "M12 12v4", "key": "svg-3" }]]);

export { IconFirstAidKit as default };
//# sourceMappingURL=IconFirstAidKit.mjs.map
